import { reactive } from 'vue';

type SnackbarColor = 'success' | 'error' | 'warning' | 'info' | 'primary';

const state = reactive({
  show: false,
  text: '',
  color: 'info' as SnackbarColor,
  timeout: 3000,
});

export const useSnackbar = () => {
  const open = (
    text: string,
    options?: {
      color?: SnackbarColor;
      timeout?: number;
    },
  ) => {
    state.text = text;
    state.color = options?.color ?? 'info';
    state.timeout = options?.timeout ?? 3000;
    state.show = true;
  };

  const close = () => {
    state.show = false;
  };

  return {
    state,
    open,
    close,
  };
};
